import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ArrowDown({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7072 19.7071L18.7072 13.7071L17.2929 12.2929L13 16.5858L13 4H11L11 16.5858L6.70715 12.2929L5.29294 13.7071L11.2929 19.7071C11.6835 20.0976 12.3166 20.0976 12.7072 19.7071Z"
        fill={iconColor}
      />
    </Svg>
  );
}
